(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-subscription-activation-messages"] && !Shopify.designMode) return;
  try {
    

const url = new URL(window.location.href);
const activation_code = url.searchParams.get("activation_code");

fetch("https://get.reelrocktour.com/api-2023/gift-of-unlimited/gift-status/?activation_code=" + activation_code).then((response) => response.json()).then((data) => {
let title;

if(data.status == "found") {
document.getElementById("rr-success-section").style.display = 'block';
} else {
document.getElementById("rr-failure-section").style.display = 'block';
}

});

  } catch(e) { console.error(e); }
})();
})();
